import AxiosInstance from 'utils/AxiosInstance'
import * as types from './constants'
/*eslint-disable */
export const toggleNewExternalReportOverlay = () => ({
  type: types.TOGGLE_OVERLAY,
})
export const onChangeExternalReportName = (value) => ({
  type: types.SET_EXTERNAL_REPORT_NAME,
  value,
})

export const setCurrentExternalReport = (value) => ({
  type: types.SET_CURRENT_EXTERNAL_REPORT,
  value,
})
export const onChangeCurrentExternalReportName = (value) => ({
  type: types.SET_CURRENT_EXTERNAL_REPORT_NAME,
  value,
})

export const toggleStatus = () => ({ type: types.TOGGLE_STATUS })
export const setPaginationItems = (items) => ({ type: types.SET_ITEMS, items })
export const setPaginationPageOfItems = (pageOfItems) => ({
  type: types.SET_PAGE_OF_ITEMS,
  pageOfItems,
})
export const toggleCurrentStatus = () => ({ type: types.TOGGLE_CURRENT_STATUS })

export const fetchExternalReports = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_EXTERNAL_REPORTS_LOADED, value: false })
    const formatedExternalReports = []
    console.log('This was called ...')
    AxiosInstance.get(`/external-reports`).then((reports) => {
      console.log('reports', reports)
      dispatch(setPaginationItems(reports))

      if (Array.isArray(reports)) {
        reports.map((item) => {
          formatedExternalReports.push({
            ...item,
          })
        })
        dispatch({
          type: types.SET_EXTERNAL_REPORTS,
          externalReports: formatedExternalReports,
        })
        dispatch({ type: types.SET_EXTERNAL_REPORTS_LOADED, value: true })
      }
    })
  }
}

export const fetchUserExternalReports = () => {
  return (dispatch, getState) => {
    const { user } = getState().auth

    AxiosInstance.get(`/external-reports/user/${user.id}`).then((reports) => {
      dispatch({
        type: types.SET_USER_EXTERNAL_REPORTS,
        payload: reports,
      })
    })
  }
}

export const addNewExternalReport = () => {
  return (dispatch, getState) => {
    const { externalReportName, externalReports, externalReportId, status } =
      getState().externalReports
    const language = getState().language.language?.data ?? {}
    if (!externalReportName) {
      alert(language.alerts ? language.alerts.type_loction_name : null)
      return
    }

    const externalReportIndex = externalReports.findIndex(
      (item) =>
        item.name.toLowerCase().trim() ===
        externalReportName.toLowerCase().trim()
    )

    if (externalReportIndex === -1) {
      AxiosInstance.post('/external-reports', {
        name: externalReportName,
      }).then(() => {
        dispatch({ type: types.TOGGLE_OVERLAY, overlayIsShowing: false })
        dispatch({
          type: types.SET_EXTERNAL_REPORT_NAME,
          externalReportName: '',
        })
        // dispatch(fetchAllStores())
        dispatch(fetchExternalReports())
      })
    } else {
      alert(language.alerts ? language.alerts.location_already_exists : null)
    }
  }
}

export const selectExternalReport = (externalReports) => {
  console.log(externalReports, 'externalReports in actions')
  const externalReportsOptions = externalReports.map(
    (externalReport) => externalReport.option
  )
  console.log(externalReports, 'externalReports')
  return {
    type: types.SELECT_EXTERNAL_REPORT,
    payload: externalReportsOptions,
  }
}

export const toggleEditOverlay = (item) => {
  return (dispatch) => {
    let formatedItem
    if (item) {
      formatedItem = {
        ...item,
        status: item.status === 'Active' ? true : false,
      }
      dispatch(setCurrentExternalReport(formatedItem))
    }

    dispatch({ type: types.TOGGLE_EDIT_OVERLAY })
  }
}

export const updateExternalReport = () => {
  return (dispatch, getState) => {
    const { currentExternalReport } = getState().externalReports
    const language = getState().language.language?.data ?? {}
    if (!currentExternalReport.name) {
      alert(language.alerts ? language.alerts.type_loction_name : null)
      return
    }

    AxiosInstance.put(`/external-reports/${currentExternalReport.id}`, {
      name: currentExternalReport.name,
      // location_id: currentExternalReport.location_id,
      // status: currentStore.status ? 1 : -1,
    }).then(() => {
      dispatch({
        type: types.TOGGLE_EDIT_OVERLAY,
        editOverlayIsShowing: false,
      })
      dispatch({ type: types.SET_EXTERNAL_REPORT_NAME })
      dispatch({ type: types.TOGGLE_STATUS })
      dispatch(fetchExternalReports())
    })
  }
}

export const deleteExternalReport = (id) => {
  return (dispatch, getState) => {
    const language = getState().language.language?.data ?? {}
    if (
      // confirm(language.alerts ? language.alerts.delete_location_confirm : null)
      confirm('Are you sure you want to delete this External report?')
    ) {
      AxiosInstance.delete(`/external-reports/${id}`).then(() => {
        dispatch(fetchExternalReports())
      })
    }
  }
}

export const setSearchValue = (searchValue) => {
  return (dispatch, getState) => {
    // const { allStores } = getState().stores
    // const filteredItems = allStores.filter(item => item.name.trim().toLowerCase().indexOf(searchValue.toLowerCase()) !== -1)
    // dispatch(setPaginationItems(filteredItems))
    dispatch({ type: types.SET_SEARCH_VALUE, searchValue })
  }
}

export const onClickSearch = () => {
  return (dispatch, getState) => {
    const { searchValue, externalReports } = getState().externalReports
    const filteredItems = externalReports.filter(
      (item) =>
        item.name.trim().toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
    )
    dispatch(setPaginationItems(filteredItems))
    dispatch({ type: types.SET_SERACH_VALUE_ON_CLICK, value: searchValue })
  }
}
export const onResetSearch = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_SERACH_VALUE_ON_CLICK, value: '' })
    dispatch({ type: types.SET_SEARCH_VALUE, searchValue: '' })
    const { searchValue, externalReports } = getState().externalReports
    const filteredItems = externalReports.filter(
      (item) =>
        item.name.trim().toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
    )
    dispatch(setPaginationItems(filteredItems))
  }
}
